module.exports = __webpack_public_path__ + "static/e-illu-6-0b187cfda8660d12360df4b9baecfb59.png";